import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installFetchRecorder } from "@jkast90/kast-common/diagnostics";
import { acceptSignInFromUrl } from "@common/auth/session";
// The shared base first: it declares the cascade layers' order (reset, kt, kui)
// and the reset. Then the app's element styles, the family palettes, the scale
// tokens and the shared UI.
import "@jkast90/kast-common/base.css";
import "./index.css";
import "@jkast90/kast-common/theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
import "@common/theme";

// Before the first request, so every call lands in bug reports' API log. The
// app's fetches don't all go through apiClient (uploads, geocoding, Cognito).
installFetchRecorder();

// Back from login.kast-dev.net: tokens out of the URL and into the session,
// and onto the page the user left, before the router reads the location.
acceptSignInFromUrl();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
